import { Dispatch } from "react-redux";
import { AuthActionCreators, IApplicationState } from "..";
import { IGet, IPost } from "../authorization";
import { ICheekSwabRequest, IBaseResponse, IHomeBloodDrawRequest, IListItem, IStreamlinedSerologyOrder } from "@nkr/models/index";

export interface ICheekSwabOrderResponse {
    data: {
        success: boolean,
        message: string,
        results: any
    }
}

export interface ISerologyTestsResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            tests: IListItem[],
            centerTests: number[]
        }
    }
}

export interface IZipCodeResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            listOfStates: IListItem[],
            city: string,
            state: string
        }
    }
}

export interface ILookupLabAddressResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            returnName: string,
            returnAddress1: string,
            returnAddress2: string,
            returnCity: string,
            returnState: string,
            returnPostalCode: string
        }
    }
}

export const OrdersActionCreators = {
    requestDonorCheekSwab: (donorId: number, request: ICheekSwabRequest) => (dispatch: Dispatch<IApplicationState>): Promise<ICheekSwabOrderResponse> => {
        var options: IPost = {
            url: `${__API__}/orders/cheek-swab/donor/${donorId}`,
            data: request
        };

        return dispatch(AuthActionCreators.apiPost(options));
    },
    createDonorOrder: (donorId: number, request: ICheekSwabRequest): any => (dispatch: Dispatch<IApplicationState>) => {
        var options: IPost = {
            url: `${__API__}/histogenetics/create-donor-order?donorId=${donorId}`,
            data: request,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiPost(options));
    },
    requestRecipientCheekSwab: (recipientId: number, request: ICheekSwabRequest) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: `${__API__}/orders/cheek-swab/recipient/${recipientId}`,
            data: request
        };

        return dispatch(AuthActionCreators.apiPost(options));
    },
    createRecipientOrder: (recipientId: number, request: ICheekSwabRequest): any => (dispatch: Dispatch<IApplicationState>) => {
        var options: IPost = {
            url: `${__API__}/histogenetics/create-recipient-order?recipientId=${recipientId}`,
            data: request,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiPost(options));
    },
    lookUpLabAddress: (centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<ILookupLabAddressResponse> => {
        var options: IGet = {
            url: `${__API__}/orders/home-blood-draw/lab-address/${centerId}`
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },
    lookUpZipCode: (code: string) => (dispatch: Dispatch<IApplicationState>): Promise<IZipCodeResponse> => {
        var options: IGet = {
            url: code ? `${__API__}/orders/home-blood-draw/zip-lookup/${code}` : `${__API__}/orders/home-blood-draw/zip-lookup`
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },
    requestHomeBloodDraw: (request: IHomeBloodDrawRequest, centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let url = `${__API__}/orders/home-blood-draw/${centerId}`;
        let options = {
            url: url,
            data: request
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    requestStreamlinedSerology: (request: IStreamlinedSerologyOrder, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/orders/streamlined-serology/${centerId}`,
            data: request
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    serologyTests: (centerId: number, organType: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyTestsResponse> => {
        let options: IGet = {
            url:`${__API__}/orders/streamlined-serology/tests/${centerId}?organType=${organType}`
        }

        return await dispatch(AuthActionCreators.apiGet(options))
    }
};